/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DateStrategyEnum {
    LATEST = 'LATEST',
    EXACT = 'EXACT',
}
